import { inject } from '@angular/core';
import {CanActivateFn, Router} from '@angular/router';
import { Store } from '@ngxs/store';
import { mergeMap, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { AppActions } from "../../app.actions";
import { AppState } from "../../app.state";
import {Route, RoutingHelperService} from "../services/routing-helper.service";

export const planGuard: CanActivateFn = (route, state) => {
  const store = inject(Store);
  const router = inject(Router)
  const routingService = inject(RoutingHelperService);
  const routes = Route;

  return store.select(AppState.getPlan).pipe(
    mergeMap((plan) => {
      if (!plan || !plan.monthlyPrice) {
        return store.dispatch(new AppActions.Plan.Get()).pipe(
          map(() => true),
          catchError(() => {
            router.navigate([routingService.getRelativePath(routes.Plans.path)]);
            return of(false);
          })
        );
      }
      return of(true);
    }),
    catchError(() => {
      router.navigate([routingService.getRelativePath(routes.Plans.path)]);
      return of(false);
    })
  );
};
